module.exports = __webpack_public_path__ + "media/stylesheets/botyglot/default-theme/20-static/icons/eye-cbcb2ea2e5d1f10380c5e71595c58140.svg";